import { useEffect, useRef, useState } from "react";
import "@/App.css";
import {
  Droplets,
  Zap,
  Leaf,
  MapPin,
  Bus,
  Instagram,
  Mail,
  Phone,
  ArrowUpRight,
  Menu,
  X,
} from "lucide-react";

/* -------------------------------------------------------------------------- */
/*  Greek content                                                             */
/* -------------------------------------------------------------------------- */

const NAV = [
  { id: "home", label: "Αρχική" },
  { id: "company", label: "Η Εταιρεία" },
  { id: "activities", label: "Τομείς Δραστηριότητας" },
  // { id: "projects", label: "Έργα" },
  { id: "contact", label: "Επικοινωνία" },
];

const NAV_IDS = NAV.map((item) => item.id);
const NAV_OFFSET = 88;

const VALUES = [
  {
    title: "Αξιοπιστία",
    body: "Στη GreenDot Hellas αντιμετωπίζουμε κάθε έργο με υπευθυνότητα, τεχνική ακρίβεια και απόλυτο σεβασμό στις προδιαγραφές. Η εμπειρία μας στον σχεδιασμό και την υλοποίηση δημοσίων έργων εξασφαλίζει λύσεις λειτουργικές, ασφαλείς και ανθεκτικές στον χρόνο. Χτίζουμε σχέσεις εμπιστοσύνης με φορείς και συνεργάτες, βασισμένες στη συνέπεια, τη διαφάνεια και την ποιότητα του αποτελέσματος.",
  },
  {
    title: "Καινοτομία",
    body: "Ενσωματώνουμε σύγχρονες τεχνικές, νέες τεχνολογίες και βέλτιστες πρακτικές σε κάθε στάδιο του έργου. Αναζητούμε συνεχώς έξυπνες και αποδοτικές λύσεις, που βελτιώνουν τη λειτουργικότητα των υποδομών και μειώνουν το κόστος και τον χρόνο υλοποίησης. Η καινοτομία για εμάς δεν είναι επιλογή, αλλά εργαλείο εξέλιξης και προστιθέμενης αξίας.",
  },
  {
    title: "Βιωσιμότητα",
    body: "Σχεδιάζουμε έργα με επίκεντρο τον άνθρωπο και το περιβάλλον. Δίνουμε έμφαση στη βιώσιμη ανάπτυξη, την ενεργειακή αποδοτικότητα και τη μείωση του περιβαλλοντικού αποτυπώματος, συμβάλλοντας σε υποδομές που εξυπηρετούν τις σημερινές ανάγκες χωρίς να υπονομεύουν το μέλλον. Η βιωσιμότητα αποτελεί βασικό κριτήριο σε κάθε μας απόφαση.",
  },
];

const ACTIVITIES = [
  {
    key: "ydreusi",
    label: "Ύδρευση",
    Icon: Droplets,
    title: "Υδραυλικά Έργα και Δίκτυα Ύδρευσης",
    text: "Τα υδραυλικά έργα αποτελούν βασικό πυλώνα δραστηριότητας της Green Dot Hellas. Εξειδικευόμαστε στον σχεδιασμό και την υλοποίηση εγκαταστάσεων επεξεργασίας υγρών αποβλήτων και νερού, με επιτυχημένα έργα μεσαίας και μεγάλης κλίμακας.",
    services: [
      "Δίκτυα αποχέτευσης ακαθάρτων και ομβρίων",
      "Διαχείριση υδατικών πόρων και επεξεργασία νερού",
      "Φράγματα, λιμνοδεξαμενές και υδρολογικές μελέτες",
      "Εγγειοβελτιωτικά έργα και αρδευτικά δίκτυα",
      "Αντιπλημμυρικά έργα και διευθέτηση χειμάρρων",
      "Λιμενικά έργα και υποθαλάσσιοι αγωγοί",
      "Μελέτες ύδρευσης και εξωτερικών υδραγωγείων",
      "Επεξεργασία αστικών και βιομηχανικών αποβλήτων",
      "Έλεγχος διαρροών και υδραυλική επάρκεια τεχνικών έργων",
    ],
  },
  {
    key: "energeia",
    label: "Ενέργεια",
    Icon: Zap,
    title: "Ενέργεια και Εξοικονόμηση",
    text: "Στρατηγική προτεραιότητα για τη Green Dot Hellas, με σύγχρονες λύσεις που ανταποκρίνονται στις ανάγκες για ασφαλείς, καθαρές και «έξυπνες» ενεργειακές υποδομές.",
    services: [
      "Σχεδιασμός υδροηλεκτρικών έργων",
      "Παραγωγή ενέργειας από βιομάζα και βιοαέριο",
      "Ανανεώσιμες πηγές ενέργειας (Α.Π.Ε.)",
      "Μελέτες εξοικονόμησης ενέργειας",
      "Τηλεχειρισμός και τηλεέλεγχος έργων αποβλήτων",
      "Τηλεματική διαχείριση οχημάτων και μηχανημάτων",
      "Βιοκλιματικός και ενεργειακός σχεδιασμός κτιρίων",
      "Ενεργειακή αναβάθμιση δημοτικών κτιρίων",
    ],
  },
  {
    key: "perivallon",
    label: "Περιβάλλον",
    Icon: Leaf,
    title: "Περιβάλλον και Διαχείριση Αποβλήτων",
    text: "Δυναμική παρουσία στη διαχείριση στερεών απορριμμάτων και ιλύος, με ολοκληρωμένες υπηρεσίες που καλύπτουν όλα τα στάδια — από τον σχεδιασμό έως την παρακολούθηση κατασκευής και λειτουργίας.",
    services: [
      "Διαχείριση στερεών αποβλήτων και ιλύος",
      "Ανακύκλωση, μηχανική-βιολογική και θερμική επεξεργασία",
      "Χ.Υ.Τ.Α. και αποκατάσταση Χ.Δ.Α.",
      "Έλεγχος και εξυγίανση ρυπασμένων συστημάτων",
      "Εναλλακτική συλλογή υγρών και στερεών αποβλήτων",
      "Μελέτες περιβαλλοντικών επιπτώσεων και αδειοδότηση",
      "Φυτοτεχνικές μελέτες και αποκατάσταση περιβάλλοντος",
      "Μεταφορά, αποθήκευση και επεξεργασία απορριμμάτων",
    ],
  },
  {
    key: "topografia",
    label: "Τοπογραφία",
    Icon: MapPin,
    title: "Τοπογραφικές Μελέτες",
    text: "Ολοκληρωμένες τοπογραφικές υπηρεσίες που υποστηρίζουν μελέτες και έργα υποδομής σε όλα τα στάδια ανάπτυξης και κατασκευής.",
    services: [
      "Δημιουργία ψηφιακών μοντέλων εδάφους",
      "Τοπογραφικές αποτυπώσεις",
      "Υψομετρικές μελέτες και χωροστάθμηση",
      "Γεωγραφικά Συστήματα Πληροφοριών (G.I.S.)",
      "Τοπογραφικά διαγράμματα πάσης φύσεως",
      "Καθορισμός αιγιαλού και παραλίας",
      "Τοπογραφικά υπόβαθρα για μελέτες οδοποιίας",
    ],
  },
  {
    key: "sygkoinonia",
    label: "Συγκοινωνιακά",
    Icon: Bus,
    title: "Συγκοινωνιακά Έργα",
    text: "Ολοκληρωμένες μελετητικές και τεχνικές λύσεις, που καλύπτουν ένα ευρύ φάσμα υποδομών μεταφορών, αστικών και υπεραστικών.",
    services: [
      "Μελέτες οδικών έργων (αστικά και υπεραστικά)",
      "Ισόπεδοι και ανισόπεδοι κόμβοι",
      "Μελέτες αγροτικής οδοποιίας",
      "Σήμανση και ασφάλιση οδών",
      "Φωτεινή σηματοδότηση",
      "Μελέτες γεφυρών και σηράγγων",
      "Διαχείριση κατασκευής και λειτουργίας έργων",
      "Σχεδιασμός και αναβάθμιση οδοφωτισμού",
    ],
  },
];

/* Client / project marks — simple SVG placeholders in the spirit of the mockup */
const CLIENTS = [
  { name: "Δήμος Γορτυνίας", type: "municipality" },
  { name: "ΔΕΥΑ Αιγιαλείας", type: "water" },
];

/* Brand assets (provided) */
function assetPath(fileName) {
  if (process.env.PUBLIC_URL && process.env.PUBLIC_URL !== ".") {
    return `${process.env.PUBLIC_URL}/assets/${fileName}`;
  }

  const script =
    document.currentScript ||
    Array.from(document.scripts).find((item) =>
      item.src.includes("/static/js/"),
    );

  if (script?.src) {
    return new URL(`../../assets/${fileName}`, script.src).toString();
  }

  return `./assets/${fileName}`;
}

const ASSETS = {
  logoPurple: assetPath("logo-purple.svg"),
  logoWhite: assetPath("logo-white.svg"),
  gGreen: assetPath("g-green.svg"),
  gWhite: assetPath("g-white.svg"),
  vien: assetPath("vien.svg"),
  hero: assetPath("hero-background.avif"),
};

/* -------------------------------------------------------------------------- */

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;

  const top =
    window.scrollY +
    el.getBoundingClientRect().top -
    (id === "home" ? 0 : NAV_OFFSET);

  window.scrollTo({ top, behavior: "smooth" });

  if (window.location.hash) {
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}`,
    );
  }
}

function handleSectionLinkClick(event, id, onNavigate, onComplete) {
  event.preventDefault();
  onNavigate?.(id);
  scrollToSection(id);
  onComplete?.();
}

function useActiveSection(ids) {
  const [active, setActive] = useState(ids[0]);
  const activeRef = useRef(ids[0]);
  const frame = useRef(null);
  const lockUntil = useRef(0);
  const releaseTimer = useRef(null);
  const evaluateRef = useRef(null);

  useEffect(() => {
    const setCurrent = (id) => {
      if (activeRef.current !== id) {
        activeRef.current = id;
        setActive(id);
      }
    };

    const evaluate = (force = false) => {
      if (!force && Date.now() < lockUntil.current) {
        return;
      }

      const y =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const last = ids[ids.length - 1];

      if (window.innerHeight + y >= document.documentElement.scrollHeight - 4) {
        setCurrent(last);
        return;
      }

      const lastEl = document.getElementById(last);
      if (
        lastEl &&
        lastEl.getBoundingClientRect().top < window.innerHeight * 0.72
      ) {
        setCurrent(last);
        return;
      }

      const marker = y + NAV_OFFSET + 96;
      let current = ids[0];

      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;

        const top = y + el.getBoundingClientRect().top;
        if (top <= marker) {
          current = id;
        }
      }

      setCurrent(current);
    };

    const handler = (force = false) => {
      if (frame.current) return;

      frame.current = window.requestAnimationFrame(() => {
        frame.current = null;
        evaluate(force);
      });
    };

    evaluateRef.current = handler;

    handler(true);
    const interval = window.setInterval(() => evaluate(), 180);
    window.addEventListener("scroll", handler, { passive: true });
    document.addEventListener("scroll", handler, {
      passive: true,
      capture: true,
    });
    window.addEventListener("resize", handler);
    window.addEventListener("load", handler);
    window.addEventListener("pageshow", handler);

    return () => {
      window.removeEventListener("scroll", handler);
      document.removeEventListener("scroll", handler, { capture: true });
      window.removeEventListener("resize", handler);
      window.removeEventListener("load", handler);
      window.removeEventListener("pageshow", handler);
      window.clearInterval(interval);
      if (frame.current) {
        window.cancelAnimationFrame(frame.current);
      }
      if (releaseTimer.current) {
        window.clearTimeout(releaseTimer.current);
      }
    };
  }, [ids]);

  const setActiveSection = (id) => {
    lockUntil.current = Date.now() + 900;
    activeRef.current = id;
    setActive(id);

    if (releaseTimer.current) {
      window.clearTimeout(releaseTimer.current);
    }

    releaseTimer.current = window.setTimeout(() => {
      lockUntil.current = 0;
      evaluateRef.current?.(true);
    }, 900);
  };

  return [active, setActiveSection];
}

/* -------------------------------------------------------------------------- */
/*  Components                                                                */
/* -------------------------------------------------------------------------- */

function Logo({ dark = false, size = 40 }) {
  return (
    <img
      src={dark ? ASSETS.logoWhite : ASSETS.logoPurple}
      alt="GreenDot Hellas"
      style={{ height: size, width: "auto", display: "block" }}
      data-testid="brand-logo"
    />
  );
}

function Navbar({ active, onNavigate }) {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md"
      style={{
        background: "rgba(243,243,240,0.78)",
        borderBottom: "1px solid var(--gd-line)",
      }}
      data-testid="site-navbar"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a
          href="#home"
          onClick={(event) => handleSectionLinkClick(event, "home", onNavigate)}
          className="flex items-center"
          data-testid="nav-logo-link"
        >
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8 text-[14px] font-medium">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(event) =>
                handleSectionLinkClick(event, item.id, onNavigate)
              }
              className={`nav-link ${active === item.id ? "active" : ""}`}
              style={{
                color: active === item.id ? "var(--gd-green)" : "var(--gd-ink)",
              }}
              data-testid={`nav-link-${item.id}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-md"
          style={{ color: "var(--gd-ink)" }}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t"
          style={{ borderColor: "var(--gd-line)", background: "var(--gd-bg)" }}
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col px-6 py-4 gap-3">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(event) =>
                  handleSectionLinkClick(event, item.id, onNavigate, () =>
                    setOpen(false),
                  )
                }
                className="text-[15px] py-2 font-medium"
                style={{
                  color:
                    active === item.id ? "var(--gd-green)" : "var(--gd-ink)",
                }}
                data-testid={`nav-mobile-link-${item.id}`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}

function Hero({ onNavigate }) {
  return (
    <section
      id="home"
      className="relative pt-[72px]"
      data-testid="section-hero"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 pt-10 md:pt-16">
        <div
          className="relative overflow-hidden rounded-[28px] grain"
          style={{
            background: `linear-gradient(180deg, rgba(30,21,42,0.92) 0%, rgba(30,21,42,0.88) 100%), url("${ASSETS.hero}") center/cover`,
            minHeight: "520px",
          }}
        >
          {/* Top status bar inside hero */}
          <div className="flex items-center justify-between px-6 md:px-10 pt-6 md:pt-8 relative z-10">
            <div
              className="flex items-center gap-2 text-xs md:text-[13px] font-medium tracking-wider uppercase"
              style={{ color: "rgba(255,255,255,0.75)" }}
              data-testid="hero-status-badge"
            >
              <span
                className="pulse-dot inline-block w-2 h-2 rounded-full"
                style={{ background: "var(--gd-green)" }}
              />
              Creating tomorrow, now
            </div>
            <div
              className="hidden md:block text-[12px] tracking-[0.2em] uppercase"
              style={{ color: "rgba(255,255,255,0.55)" }}
            >
              Athens · Greece
            </div>
          </div>

          {/* Central spinning badge + big text */}
          <div className="relative z-10 flex flex-col items-center text-center px-6 pt-10 pb-20 md:pt-14 md:pb-24">
            <div className="relative mb-10 fade-up">
              <svg
                viewBox="0 0 220 220"
                width="220"
                height="220"
                className="spin-slow"
                aria-hidden="true"
              >
                <defs>
                  <path
                    id="circlePath"
                    d="M 110,110 m -86,0 a 86,86 0 1,1 172,0 a 86,86 0 1,1 -172,0"
                  />
                </defs>
                <text
                  fill="rgba(255,255,255,0.9)"
                  fontFamily="Unbounded, sans-serif"
                  fontSize="13"
                  fontWeight="500"
                  letterSpacing="4"
                >
                  <textPath
                    href="#circlePath"
                    startOffset="0"
                    letterSpacing="6.5px"
                  >
                    ΑΞΙΟΠΙΣΤΙΑ · ΚΑΙΝΟΤΟΜΙΑ · ΒΙΩΣΙΜΟΤΗΤΑ ·
                  </textPath>
                </text>
              </svg>
              {/* Center G mark */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="flex items-center justify-center rounded-full"
                  style={{
                    width: 96,
                    height: 96,
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.18)",
                    backdropFilter: "blur(6px)",
                  }}
                >
                  <img
                    src={ASSETS.gGreen}
                    alt="GreenDot Hellas green G mark"
                    style={{ width: 48, height: 48, display: "block" }}
                    data-testid="hero-g-mark"
                  />
                </div>
              </div>
            </div>

            <h1
              className="font-display fade-up delay-1"
              style={{
                color: "#fff",
                fontSize: "clamp(30px, 6vw, 84px)",
                fontWeight: 600,
                letterSpacing: "-0.03em",
                lineHeight: 1.05,
                maxWidth: 900,
              }}
              data-testid="hero-headline"
            >
              Χτίζουμε το{" "}
              <span style={{ color: "var(--gd-green)" }}>αύριο</span>
              <br />
              με συνέπεια και τεχνογνωσία.
            </h1>
            <p
              className="mt-6 max-w-[620px] text-[15px] md:text-[17px] leading-relaxed fade-up delay-2"
              style={{ color: "rgba(255,255,255,0.72)" }}
              data-testid="hero-subhead"
            >
              Εξειδικευμένες υπηρεσίες υποστήριξης για την υλοποίηση ευρωπαϊκών
              και εθνικών επιχειρησιακών προγραμμάτων σε δημόσιο και ιδιωτικό
              τομέα.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-3 mt-10 fade-up delay-3">
              <a
                href="#company"
                onClick={(event) =>
                  handleSectionLinkClick(event, "company", onNavigate)
                }
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-[14px] transition-all duration-300 hover:translate-y-[-2px]"
                style={{
                  background: "var(--gd-green)",
                  color: "var(--gd-ink)",
                  boxShadow: "0 10px 30px -10px rgba(19,184,85,0.55)",
                }}
                data-testid="hero-cta-learn-more"
              >
                Μάθετε περισσότερα
                <ArrowUpRight size={16} strokeWidth={2.5} />
              </a>
              <a
                href="#contact"
                onClick={(event) =>
                  handleSectionLinkClick(event, "contact", onNavigate)
                }
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium text-[14px] transition-all duration-300 hover:translate-y-[-2px]"
                style={{
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.22)",
                }}
                data-testid="hero-cta-contact"
              >
                Επικοινωνία
              </a>
            </div>
          </div>

          {/* Bottom marquee */}
          <div
            className="marquee absolute bottom-0 left-0 right-0 py-5 border-t"
            style={{
              background: "rgba(30,21,42,0.6)",
              borderColor: "rgba(255,255,255,0.08)",
            }}
            data-testid="hero-marquee"
          >
            <div className="marquee-track">
              {Array.from({ length: 2 }).flatMap((_, r) => {
                const cities = [
                  "Αθήνα",
                  "Θεσσαλονίκη",
                  "Πάτρα",
                  "Ιωάννινα",
                  "Βόλος",
                  "Λάρισα",
                  "Ρόδος",
                  "Μήλος",
                  "Τρίπολη",
                  "Αίγιο",
                  "Καλάβρυτα",
                  "Γορτυνία",
                ];
                const items = [];
                cities.forEach((c) => {
                  items.push(c);
                  items.push("•");
                });
                return items.map((t, i) => (
                  <span
                    key={`${r}-${i}`}
                    className="font-display text-[20px] md:text-[34px]"
                    style={{
                      color:
                        t === "•"
                          ? "var(--gd-green)"
                          : "rgba(255,255,255,0.85)",
                      fontWeight: 500,
                      letterSpacing: "-0.02em",
                    }}
                  >
                    {t}
                  </span>
                ));
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ValuesCards() {
  return (
    <section
      className="max-w-[1280px] mx-auto px-6 md:px-10 mt-16 md:mt-24"
      data-testid="section-values"
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
        {VALUES.map((v, idx) => (
          <article
            key={v.title}
            className="rounded-[20px] p-7 md:p-8 fade-up"
            style={{
              background: "var(--gd-card)",
              border: "1px solid var(--gd-line)",
              animationDelay: `${idx * 120}ms`,
            }}
            data-testid={`value-card-${idx}`}
          >
            <div
              className="flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase"
              style={{ color: "var(--gd-muted)" }}
            >
              <span
                className="w-6 h-px"
                style={{ background: "var(--gd-green)" }}
              />
              0{idx + 1}
            </div>
            <h3
              className="font-display mt-4 text-[26px] md:text-[30px]"
              style={{
                color: "var(--gd-ink)",
                fontWeight: 600,
                letterSpacing: "-0.02em",
              }}
            >
              {v.title}
            </h3>
            <p
              className="mt-5 text-[15px] leading-[1.7]"
              style={{ color: "var(--gd-muted)" }}
            >
              {v.body}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}

function CompanySection() {
  return (
    <section
      id="company"
      className="max-w-[1280px] mx-auto px-6 md:px-10 mt-10 md:mt-14 scroll-mt-24"
      data-testid="section-company"
    >
      <div
        className="relative overflow-hidden rounded-[24px] p-8 md:p-14 grain"
        style={{
          background: "var(--gd-ink)",
          color: "#fff",
        }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 relative z-10">
          <div className="lg:col-span-4">
            <div
              className="flex items-center gap-2 text-[12px] tracking-[0.25em] uppercase"
              style={{ color: "rgba(255,255,255,0.5)" }}
            >
              <span
                className="w-6 h-px"
                style={{ background: "var(--gd-green)" }}
              />
              About
            </div>
            <h2
              className="font-display mt-4 text-[40px] lg:text-[48px]"
              style={{
                color: "var(--gd-green)",
                fontWeight: 600,
                letterSpacing: "-0.03em",
                lineHeight: 1,
              }}
              data-testid="company-heading"
            >
              Η Εταιρεία
            </h2>
          </div>
          <div
            className="lg:col-span-8 space-y-5 text-[15px] md:text-[16px] leading-[1.75]"
            style={{ color: "rgba(255,255,255,0.82)" }}
          >
            <p>
              Η <strong style={{ color: "#fff" }}>Green Dot Hellas</strong>{" "}
              παρέχει εξειδικευμένες υπηρεσίες υποστήριξης προς τη δημόσια
              διοίκηση, συμβάλλοντας στην αποτελεσματική υλοποίηση ευρωπαϊκών
              και εθνικών επιχειρησιακών προγραμμάτων.
            </p>
            <p>
              Με υψηλή τεχνογνωσία, υπευθυνότητα και προσήλωση στην ποιότητα,
              προσφέρουμε ολοκληρωμένες λύσεις που καλύπτουν όλο τον κύκλο ζωής
              των έργων — από τον σχεδιασμό έως την υλοποίηση και την παράδοση.
            </p>
            <p>
              Μέσα από στρατηγικές συνεργασίες στην Ελλάδα και το εξωτερικό,
              υλοποιούμε σύνθετα έργα με μετρήσιμα αποτελέσματα για τον δημόσιο
              και ιδιωτικό τομέα, προς όφελος της τοπικής αυτοδιοίκησης και της
              βιώσιμης ανάπτυξης.
            </p>
          </div>
        </div>

        {/* Decorative G */}
        <img
          src={ASSETS.gWhite}
          alt=""
          aria-hidden="true"
          className="absolute bottom-[-20px] right-[-10px] select-none pointer-events-none"
          style={{
            width: 240,
            height: 240,
            opacity: 0.08,
          }}
          data-testid="company-decorative-g"
        />
      </div>
    </section>
  );
}

function ActivitiesSection() {
  const [active, setActive] = useState(ACTIVITIES[0].key);
  const current = ACTIVITIES.find((a) => a.key === active);
  const detailRef = useRef(null);

  const handleSelect = (key) => {
    setActive(key);
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(max-width: 767px)").matches) return;
    // Defer scroll so React commits the new content first
    setTimeout(() => {
      detailRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 50);
  };

  return (
    <section
      id="activities"
      className="mt-24 md:mt-32 scroll-mt-24"
      data-testid="section-activities"
    >
      <div
        className="border-t pt-14 md:pt-20"
        style={{ borderColor: "var(--gd-line)" }}
      >
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          {/* Section header */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
            <div>
              <div
                className="flex items-center gap-2 text-[12px] tracking-[0.25em] uppercase"
                style={{ color: "var(--gd-muted)" }}
              >
                <span
                  className="w-6 h-px"
                  style={{ background: "var(--gd-green)" }}
                />
                Τι κάνουμε
              </div>
              <h2
                className="font-display mt-4 text-[42px] md:text-[64px]"
                style={{
                  color: "var(--gd-green)",
                  fontWeight: 600,
                  letterSpacing: "-0.03em",
                  lineHeight: 1,
                }}
                data-testid="activities-heading"
              >
                Τομείς Δραστηριότητας
              </h2>
            </div>
            <p
              className="md:max-w-[380px] text-[15px] leading-[1.7]"
              style={{ color: "var(--gd-muted)" }}
            >
              Επιλέξτε έναν τομέα για να δείτε αναλυτικά τις υπηρεσίες και την
              εξειδίκευσή μας.
            </p>
          </div>

          {/* Icon grid — sticky on mobile, static on desktop */}
          <div
            className="sticky top-[72px] z-30 -mx-6 px-6 py-3 bg-[color:var(--gd-bg)] border-b border-[color:var(--gd-line)] md:static md:mx-0 md:px-0 md:py-0 md:bg-transparent md:border-b-0"
            data-testid="activities-grid-wrapper"
          >
            <div
              className="grid grid-cols-5 gap-1.5 md:gap-4"
              data-testid="activities-grid"
            >
              {ACTIVITIES.map(({ key, label, Icon }) => {
                const isActive = key === active;
                return (
                  <button
                    key={key}
                    type="button"
                    onClick={() => handleSelect(key)}
                    className="activity-tile rounded-[12px] md:rounded-[18px] px-1 py-3 md:px-4 md:py-8 flex flex-col items-center justify-center text-center"
                    style={{
                      background: isActive ? "var(--gd-ink)" : "var(--gd-card)",
                      color: isActive ? "#fff" : "var(--gd-ink)",
                      border: `1px solid ${isActive ? "var(--gd-ink)" : "var(--gd-line)"}`,
                    }}
                    aria-pressed={isActive}
                    data-testid={`activity-tile-${key}`}
                  >
                    <Icon
                      className="w-6 h-6 md:w-[38px] md:h-[38px]"
                      strokeWidth={1.6}
                      color={isActive ? "var(--gd-green)" : "var(--gd-ink)"}
                    />
                    <span
                      className="hidden md:inline-block mt-4 text-[15px] font-semibold leading-tight"
                      style={{
                        color: isActive ? "#fff" : "var(--gd-ink)",
                      }}
                    >
                      {label}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Dynamic detail panel */}
          <div
            ref={detailRef}
            key={current.key}
            className="mt-10 md:mt-12 rounded-[22px] p-8 md:p-10 fade-up scroll-mt-[160px] md:scroll-mt-24"
            style={{
              background: "var(--gd-card)",
              border: "1px solid var(--gd-line)",
            }}
            data-testid="activity-detail"
          >
            <div className="grid md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-3 flex md:block">
                <div
                  className="inline-flex items-center justify-center rounded-2xl"
                  style={{
                    width: 96,
                    height: 96,
                    background: "var(--gd-ink)",
                  }}
                >
                  <current.Icon
                    size={48}
                    strokeWidth={1.6}
                    color="var(--gd-green)"
                  />
                </div>
              </div>
              <div className="md:col-span-9">
                <div
                  className="text-[12px] tracking-[0.25em] uppercase"
                  style={{ color: "var(--gd-green-soft)" }}
                  data-testid="activity-detail-label"
                >
                  {current.label}
                </div>
                <h3
                  className="font-display mt-2 text-[28px] md:text-[34px]"
                  style={{
                    color: "var(--gd-ink)",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                    lineHeight: 1.1,
                  }}
                  data-testid="activity-detail-title"
                >
                  {current.title}
                </h3>
                <p
                  className="mt-5 text-[15px] md:text-[16px] leading-[1.8]"
                  style={{ color: "var(--gd-muted)" }}
                  data-testid="activity-detail-text"
                >
                  {current.text}
                </p>

                {current.services && current.services.length > 0 && (
                  <div className="mt-7" data-testid="activity-detail-services">
                    <div
                      className="flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase mb-4"
                      style={{ color: "var(--gd-ink)" }}
                    >
                      <span
                        className="w-5 h-px"
                        style={{ background: "var(--gd-green)" }}
                      />
                      Εξειδικευμένες Υπηρεσίες
                    </div>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                      {current.services.map((s, i) => (
                        <li
                          key={i}
                          className="flex items-start gap-3 text-[14px] md:text-[15px] leading-[1.55]"
                          style={{ color: "var(--gd-ink)" }}
                          data-testid={`activity-service-${i}`}
                        >
                          <span
                            className="mt-[8px] flex-shrink-0 rounded-full"
                            style={{
                              width: 6,
                              height: 6,
                              background: "var(--gd-green)",
                            }}
                          />
                          <span>{s}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ClientMark({ client }) {
  if (client.type === "municipality") {
    return (
      <div
        className="flex items-center gap-4 px-8 py-6 rounded-[18px] min-w-[260px]"
        style={{ background: "#fff", border: "1px solid var(--gd-line)" }}
      >
        <div
          className="flex items-center justify-center rounded-full"
          style={{
            width: 52,
            height: 52,
            border: "2px solid var(--gd-ink)",
            color: "var(--gd-ink)",
          }}
        >
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <path d="M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6" />
          </svg>
        </div>
        <div>
          <div
            className="font-display text-[13px] tracking-wider uppercase"
            style={{ color: "var(--gd-ink)", fontWeight: 700 }}
          >
            Δήμος
          </div>
          <div
            className="font-display text-[20px] leading-none mt-1"
            style={{
              color: "var(--gd-ink)",
              fontWeight: 700,
              letterSpacing: "0.04em",
            }}
          >
            ΓΟΡΤΥΝΙΑΣ
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="flex items-center gap-4 px-8 py-6 rounded-[18px] min-w-[260px]"
      style={{ background: "#fff", border: "1px solid var(--gd-line)" }}
    >
      <div
        className="flex items-center justify-center rounded-full"
        style={{
          width: 52,
          height: 52,
          background: "#E8F3FA",
          color: "#2B8FC7",
        }}
      >
        <Droplets size={26} />
      </div>
      <div>
        <div
          className="font-display text-[22px] leading-none"
          style={{ color: "#2B8FC7", fontWeight: 800, letterSpacing: "0.05em" }}
        >
          ΔΕΥΑ
        </div>
        <div
          className="text-[12px] tracking-[0.2em] uppercase mt-1"
          style={{ color: "#6B6880", fontWeight: 600 }}
        >
          Αιγιαλείας
        </div>
      </div>
    </div>
  );
}

function ProjectsSection() {
  return (
    <section
      id="projects"
      className="max-w-[1280px] mx-auto px-6 md:px-10 mt-20 md:mt-28 scroll-mt-24"
      data-testid="section-projects"
      hidden
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
        <div>
          <div
            className="flex items-center gap-2 text-[12px] tracking-[0.25em] uppercase"
            style={{ color: "var(--gd-muted)" }}
          >
            <span
              className="w-6 h-px"
              style={{ background: "var(--gd-green)" }}
            />
            Πελάτες & Συνεργάτες
          </div>
          <h2
            className="font-display mt-4 text-[42px] md:text-[64px]"
            style={{
              color: "var(--gd-green)",
              fontWeight: 600,
              letterSpacing: "-0.03em",
              lineHeight: 1,
            }}
            data-testid="projects-heading"
          >
            Έργα
          </h2>
        </div>
        <p
          className="md:max-w-[380px] text-[15px] leading-[1.7]"
          style={{ color: "var(--gd-muted)" }}
        >
          Συνεργαζόμαστε με δήμους και φορείς ανά την Ελλάδα για την υλοποίηση
          έργων τοπικής ανάπτυξης.
        </p>
      </div>

      <div className="flex flex-wrap gap-5">
        {CLIENTS.map((c) => (
          <ClientMark client={c} key={c.name} />
        ))}
      </div>
    </section>
  );
}

function StatsBanner() {
  return (
    <section
      className="mt-20 md:mt-28"
      style={{ background: "var(--gd-green)" }}
      data-testid="section-stats-banner"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div className="flex items-center gap-4 lg:gap-6">
          <span
            className="inline-flex items-center px-3 py-1 rounded-full text-[11px] tracking-[0.25em] uppercase font-semibold whitespace-nowrap"
            style={{
              background: "rgba(30,21,42,0.12)",
              color: "var(--gd-ink)",
            }}
          >
            Έτος Ίδρυσης
          </span>
          <div
            className="font-display text-[36px] lg:text-[72px] leading-none"
            style={{
              color: "var(--gd-ink)",
              fontWeight: 600,
              letterSpacing: "-0.03em",
            }}
          >
            2020
          </div>
        </div>
        <div className="flex items-center gap-4 lg:gap-6 lg:justify-end">
          <span
            className="inline-flex items-center px-3 py-1 rounded-full text-[11px] tracking-[0.25em] uppercase font-semibold whitespace-nowrap"
            style={{
              background: "rgba(30,21,42,0.12)",
              color: "var(--gd-ink)",
            }}
          >
            Έδρα
          </span>
          <div
            className="font-display text-[24px] lg:text-[56px] leading-none"
            style={{
              color: "var(--gd-ink)",
              fontWeight: 600,
              letterSpacing: "-0.03em",
            }}
          >
            Αθήνα, Ελλάδα
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer
      id="contact"
      className="scroll-mt-24"
      style={{ background: "var(--gd-ink)", color: "#fff" }}
      data-testid="section-footer"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo dark size={40} />
            <p
              className="mt-5 text-[14px] leading-[1.7] max-w-[320px]"
              style={{ color: "rgba(255,255,255,0.6)" }}
            >
              Συνδυάζουμε μηχανική, τεχνογνωσία και βιωσιμότητα για έργα που
              μένουν στον χρόνο.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div
              className="text-[11px] tracking-[0.3em] uppercase mb-4"
              style={{ color: "rgba(255,255,255,0.45)" }}
            >
              Get in Touch
            </div>
            <a
              href="mailto:info@greendothellas.gr"
              className="group flex items-start gap-3 text-[15px] font-medium transition-colors duration-200 hover:text-[color:var(--gd-green)]"
              data-testid="footer-email"
            >
              <Mail size={18} className="mt-0.5" />
              info@greendothellas.gr
            </a>
          </div>

          <div className="lg:col-span-3">
            <div
              className="text-[11px] tracking-[0.3em] uppercase mb-4"
              style={{ color: "rgba(255,255,255,0.45)" }}
            >
              Call Us
            </div>
            <a
              href="tel:+306972247730"
              className="group flex items-start gap-3 text-[15px] font-medium transition-colors duration-200 hover:text-[color:var(--gd-green)]"
              data-testid="footer-phone"
            >
              <Phone size={18} className="mt-0.5" />
              697 224 7730
            </a>
          </div>

          <div className="lg:col-span-2">
            <div
              className="text-[11px] tracking-[0.3em] uppercase mb-4"
              style={{ color: "rgba(255,255,255,0.45)" }}
            >
              Connect
            </div>
            <a
              href="https://www.instagram.com/green.dot.hellas/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 text-[15px] font-medium transition-colors duration-200 hover:text-[color:var(--gd-green)]"
              data-testid="footer-instagram"
            >
              <Instagram size={18} />
              Instagram
            </a>
          </div>
        </div>

        <div
          className="mt-14 pt-6 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 text-[12px]"
          style={{
            borderTop: "1px solid rgba(255,255,255,0.08)",
            color: "rgba(255,255,255,0.5)",
          }}
        >
          <div>
            © {new Date().getFullYear()} GreenDot Hellas — Όλα τα δικαιώματα
            διατηρούνται.
          </div>
          <div className="flex items-center gap-2">
            <span>Designed by</span>
            <img
              src={ASSETS.vien}
              alt="Vien logo"
              style={{ height: 14, width: "auto", display: "block" }}
              data-testid="footer-vien-mark"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

/* -------------------------------------------------------------------------- */

function App() {
  const [active, setActive] = useActiveSection(NAV_IDS);
  return (
    <div className="App min-h-screen">
      <Navbar active={active} onNavigate={setActive} />
      <Hero onNavigate={setActive} />
      <ValuesCards />
      <CompanySection />
      <ActivitiesSection />
      <ProjectsSection />
      <StatsBanner />
      <Footer />
    </div>
  );
}

export default App;
